import { addDays, isBefore } from 'date-fns';
import _get from 'lodash/get';
import DateUtils from '../../utils/date/DateUtils';
export function getHourToDisplay(hourDay, timezone) {
  var _hourDay$hoursValue = hourDay.hoursValue,
    hoursValue = _hourDay$hoursValue === void 0 ? [] : _hourDay$hoursValue,
    _hourDay$hours = hourDay.hours,
    hours = _hourDay$hours === void 0 ? [] : _hourDay$hours;
  var now = DateUtils.getTimezoneAwareNow(timezone);
  var openHourIndex = hours.findIndex(function (_ref) {
    var close = _ref.close;
    var hourClose = DateUtils.parseHourInt(close, {
      referenceDate: now
    });
    // only show the first hour set that is not in the past
    return now < hourClose;
  });
  // if all hour sets have passed, show the last one
  var lastIndex = hoursValue.length - 1;
  return openHourIndex >= 0 ? hoursValue[openHourIndex] : _get(hoursValue, "[".concat(lastIndex, "]"), '');
}
export function getPopUpLabelForDaily(hourDay, timezone) {
  var label = '';
  var secondaryLabel = '';
  if (!hourDay) {
    label = 'See hours';
  } else {
    var _hourDay$dayLabel = hourDay.dayLabel,
      dayLabel = _hourDay$dayLabel === void 0 ? '' : _hourDay$dayLabel;
    label = dayLabel;
    secondaryLabel = getHourToDisplay(hourDay, timezone);
  }
  return [label, secondaryLabel];
}
export function hourOfOperationToOpenAndCloseDate(hourOfOperation, timezone) {
  var referenceDate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  var open = hourOfOperation.open,
    close = hourOfOperation.close;
  var openTimeString = open.toString().padStart(4, '0');
  var openMoment = DateUtils.parse(openTimeString, 'HHmm', {
    timezone: timezone,
    referenceDate: referenceDate
  });
  var closeTimeString = close.toString().padStart(4, '0');
  var closeMoment = DateUtils.parse(closeTimeString, 'HHmm', {
    timezone: timezone,
    referenceDate: referenceDate
  });
  if (isBefore(closeMoment, openMoment)) {
    closeMoment = addDays(closeMoment, 1);
  }
  return {
    openMoment: openMoment,
    closeMoment: closeMoment
  };
}